/* eslint-disable react/jsx-props-no-spreading, react/prop-types */
import React from 'react';
import castArray from 'lodash/castArray';

import { TableTotal, Input } from '@atoms';
import { TableHeader, TableSelect } from '@molecules';
import { SORT_OPTIONS, DEFAULT_SORT } from '@api/constants';

import { ACTION_OPTIONS } from './constants';

export const renderRecordTableHeader = ({ selection, search, filter, secondFilter, sort, info, ...props }) => {
  const filters = castArray(filter).filter(Boolean);
  const secondFilters = castArray(secondFilter).filter(Boolean);

  return (
    <TableHeader {...props}>
      {selection && (
        <>
          <TableHeader.CheckBox>{selection.checkbox}</TableHeader.CheckBox>
          <TableHeader.Item>
            <TableSelect
              options={selection.options || ACTION_OPTIONS}
              disabled={selection.disabled}
              onSelect={selection.onOptionSelect}
              placeholder={selection.placeholder || 'Options'}
              resetAfter
            />
          </TableHeader.Item>
        </>
      )}
      {search && (
        <TableHeader.Item>
          <Input.Search
            placeholder={search.placeholder || 'Search'}
            onSearch={search.onSearch}
            defaultValue={search.defaultValue}
            style={{ width: 150, ...search.style }}
          />
        </TableHeader.Item>
      )}
      {info && (
        <TableHeader.Item flex="1" style={{ textAlign: 'center', ...info.style }}>
          <TableTotal total={info.total} singular={info.singularName} plural={info.pluralName} />
          {info.selected ? `/ ${info.selected} selected` : ''}
        </TableHeader.Item>
      )}
      {filters.length > 0 && (
        <TableHeader.Item>
          {filters.map(({ key, component: Component = TableSelect, ...filterProps }, idx) => (
            <Component key={key || idx} {...filterProps} />
          ))}
        </TableHeader.Item>
      )}
      {secondFilters.length > 0 && (
        <TableHeader.Item>
          {secondFilters.map(({ key, component: Component = TableSelect, ...secondFilterProps }, idx) => (
            <Component key={key || idx} {...secondFilterProps} />
          ))}
        </TableHeader.Item>
      )}
      {sort && (
        <TableHeader.Item>
          <TableSelect
            options={sort.options || SORT_OPTIONS}
            defaultValue={sort.defaultValue || DEFAULT_SORT.key}
            onSelect={sort.onSelect}
          />
        </TableHeader.Item>
      )}
    </TableHeader>
  );
};
